import React, { useEffect, useState } from 'react';
import ChatMarkdown from './ChatMarkdown';
import ChatAnswer from './ChatAnswer';

// Current activity only. No timed stage rotation or retained activity log.
export default function ChatLiveProgress({ progress, draft, layout = null }) {
  const [mountedAt] = useState(Date.now);
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const elapsed = Math.max(0, Math.floor((now - (progress?.startedAt || mountedAt)) / 1000));
  const line = draft ? 'Writing…' : (progress?.line || 'Working on your question…');
  return (
    <div className="hm-live-progress" data-testid="hm-chat-progress">
      {/* Lane 1400 WS1: "I couldn't read <file>", sent before any answer text.
          Absent unless CHAT_UPLOAD_HONESTY_ENABLED is on and a file failed. */}
      {progress?.notice && <div className="hm-attachnote" role="note">{progress.notice}</div>}
      {draft && (
        <div data-testid="hm-chat-stream-draft">
          {/* Lane 1405 v3 Part B: a layout draft renders its finished lines as
              parts; with no layout version it is exactly as before. */}
          {layout
            ? <ChatAnswer content={draft} layout={layout} isDraft />
            : <ChatMarkdown content={draft} isDraft />}
        </div>
      )}
      <div className={`hm-live-status${draft ? ' is-writing' : ''}`}>
        <div className="hm-dots" aria-hidden="true">
          {[0, 1, 2].map(i => <div key={i} className="hm-dot" style={{ animationDelay: `${i * 0.16}s` }} />)}
        </div>
        <span role="status" aria-live="polite" aria-atomic="true">{line}</span>
        {!draft && elapsed > 0 && <span className="hm-live-elapsed" aria-hidden="true">{elapsed}s</span>}
      </div>
    </div>
  );
}
